import './error-screen.css';

/**
 * ErrorScreen component displays a full-screen error message with retry option
 * @param {Object} props
 * @param {string} props.message - Error message to display
 * @param {Function} props.onRetry - Function to call when retry button is clicked
 * @param {boolean} props.showRetry - Whether to show the retry button
 */
const ErrorScreen = ({ message, onRetry, showRetry = true }) => {
  return (
    <div className="es-root">
      <div className="es-container">
        <div className="es-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#f44336" strokeWidth="2" />
            <line
              x1="15"
              y1="9"
              x2="9"
              y2="15"
              stroke="#f44336"
              strokeWidth="2"
            />
            <line
              x1="9"
              y1="9"
              x2="15"
              y2="15"
              stroke="#f44336"
              strokeWidth="2"
            />
          </svg>
        </div>
        <h2 className="es-title">Có lỗi xảy ra</h2>
        <p className="es-message">{message}</p>
        {showRetry && (
          <button className="es-retry-btn" onClick={onRetry}>
            Thử lại
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorScreen;
